import { Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, FormBuilder, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subscription } from 'rxjs';
import { fadeAnimation } from 'src/animations';
import { IssueOverviewModel, PaginationPage } from 'src/app/classes';
import { IssueService } from 'src/app/lib/issue/services/issue.service';

@Component({
  selector: 'app-select-issue',
  templateUrl: './select-issue.component.html',
  styleUrls: ['./select-issue.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectIssueComponent),
      multi: true
    }
  ],
  animations: [ fadeAnimation ]
})
export class SelectIssueComponent implements ControlValueAccessor, OnDestroy, OnInit {

  @Input() appearance: 'standard' | 'fill' | 'outline' = 'fill';

  page: PaginationPage = { 'pageNumber': 1, 'pageSize': 20 };

  currentSelection: IssueOverviewModel = null;
  formGroup: FormGroup;
  issues: IssueOverviewModel[] = [];
  totalItems: number = 0;

  private _subscriptions: Subscription[] = [];

  constructor(
    private _issueService: IssueService,
    private _formBuilder: FormBuilder
  ) {
    this.formGroup = this._formBuilder.group({
      filter: null,
      value: null
    });
  }

  loadMore(){
    this.page.pageNumber++;
    this.search(this.formGroup.controls['filter'].value);
  }

  ngOnDestroy(): void {

  }

  ngOnInit(): void {
  }

  public onTouched: () => void = () => { };
  registerOnTouched = (fn: any) => this.onTouched = fn;

  registerOnChange(fn: any): void {
    this._subscriptions.push(this.formGroup.controls['value'].valueChanges.subscribe(fn));
  }

  search(search: string){
    this._issueService.searchIssuesByString(search, this.page).subscribe((result) => {
      if(result.page.pageNumber === 1) this.issues = [];
      this.totalItems = result.totalItems;
      this.issues = [...this.issues, ...result.content];
      this.page = result.page;
    });
  }

  selectIssue(issue: IssueOverviewModel){
    this.currentSelection = issue;
    this.formGroup.controls['value'].setValue(issue.issueid);
    if ("activeElement" in document) (document.activeElement as HTMLDivElement).blur();
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.formGroup.controls['value'].disable() : this.formGroup.controls['value'].enable();
  }

  writeValue = (val: any) => this.formGroup.controls['value'].patchValue(val);

}
